/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WidgetType {
	List = 1,
	PieChart = 2,
	Banner = 3,
}
